import { File } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Empty state component for file attachments
 * Displays a message when no file attachments are available
 */
export default function FileAttachmentEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 p-4">
      <File className="size-8 text-muted-foreground" />
      <p className="text-center text-sm text-muted-foreground">
        {t("chatDetailsTabs.no_files")}
      </p>
    </div>
  );
}
